import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import CompanyView from '@/views/CompanyView.vue'
import AboutView from '@/views/AboutView.vue'
import JobView from '@/views/JobView.vue'
import JobDetailsView from '@/views/JobDetailsView.vue'
import MaintenanceView from '@/views/MaintenanceView.vue'
import ProjectView from '@/views/ProjectView.vue'
import UsView from '@/views/UsView.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'home', component: HomeView },
  { path: '/about', name: 'about', component: AboutView },
  { path: '/company', name: 'company', component: CompanyView },
  { path: '/job', name: 'job', component: JobView },
  { path: '/job-details', name: 'job-details', component: JobDetailsView },
  { path: '/maintenance', name: 'maintenance', component: MaintenanceView },
  { path: '/project', name: 'project', component: ProjectView },
  { path: '/us', name: 'us', component: UsView },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
